import request from './index';
import { ICompanyResponse, ICompaniesResponse } from 'types/company';

/**
 * Lista firm main (centrala) — do wyboru firmy przy przełączaniu kontekstu (superadmin).
 */
export const getMainCompanies = () =>
  request<ICompaniesResponse>({
    options: {
      url: '/company_context/companies',
      method: 'get'
    }
  });

/**
 * Przełącza kontekst na wybraną firmę (tylko dla superadmina)
 * @param companyId - ID firmy do przełączenia (UUID string)
 * @returns Promise z danymi wybranej firmy
 */
export const switchCompany = (companyId: string) =>
  request<ICompanyResponse>({
    options: {
      url: '/company_context',
      method: 'patch',
      data: { company_id: companyId }
    }
  });
